<template lang="pug">
  .pho-file-input
    slot(name="activator" :on="on")
      v-btn.text-capitalize(v-on="on")
        | {{ $t($lang.file.UPLOAD_FILE) }}
    input.file-input(
      ref="inputRef"
      type="file"
      name="file"
      :accept="accept"
      :multiple="multiple"
      @change="onChange"
    )
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'PhoFileInput',
  props: {
    accept: {
      type: String,
      default: '*',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onChange'],
  setup(props, { emit }) {
    const inputRef = ref(undefined);

    const selectFile = () => {
      inputRef.value.click();
    };

    const onChange = event => {
      emit('onChange', event);
    };

    const clear = () => {
      inputRef.value.value = null;
    };

    return {
      on: {
        click: selectFile,
      },
      inputRef,
      onChange,
      clear,
    };
  },
};
</script>
